module.exports = __webpack_public_path__ + "img/1F627.fc17bdb3.svg";